import tokens from '@nike/design-system-base';

// Value Reference:
// headerTitle4 = 20px
// headerTitle3 = 24px

//  xxs: 12px;
//  xs: 14px;
//  baseline/s: 16px;
//  m: 20px;
//  l: 24px;
//  xl: 28px;

// font-weight-regular: 400;
// font-weight-medium: 500;
// font-weight-bold: 700;

const fonts = {
  baseFamily: 'var(--podium-cds-typography-body1)',
  baseFamilyBold: 'var(--podium-cds-typography-body1-strong)',
  headerTitle4: 'var(--podium-cds-typography-320-to-1919-title4)',
  headerFamily: 'var(--podium-cds-typography-320-to-1919-title3)',
  sizes: {
    xs: 'var(--podium-cds-font-size-xs)',
    sm: 'var(--podium-cds-font-size-s)',
    baseline: 'var(--podium-cds-font-size-s)',
    md: 'var(--podium-cds-font-size-m)',
    lg: 'var(--podium-cds-font-size-l)',
    xl: 'var(--podium-cds-font-size-xl)',
  },
  weight: {
    regular: 'var(--podium-cds-font-weight-regular)',
    medium: 'var(--podium-cds-font-weight-medium)',
    bold: 'var(--podium-cds-font-weight-bold)',
  },
  lineHeights: {
    ...tokens.get('type.lineHeight'),
    header: {
      sm: tokens.get('type.lineHeight.mobile.14'),
      md: tokens.get('type.lineHeight.mobile.24'),
    },
  },
};

export default fonts;
